import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { EstampApiKeyService } from '../services/estamp-api-key.service';

export const ESTAMP_API_PREFIX = '/bulk-estamp-api';

/**
 * Sends the eStamp `x-api-key` (instead of the customer JWT) for every demo
 * eStamp call.
 *
 * Only `bulk-estamp-api/*` urls are touched, so the eSign key attached by
 * {@link EsignApiKeyInterceptor} to `documents-api/*` stays untouched — the two
 * demos always authenticate with their own key.
 *
 * Must run before {@link EnvironmentInterceptor}, which is what prefixes the
 * relative url with the environment base url.
 */
@Injectable()
export class EstampApiKeyInterceptor implements HttpInterceptor {

  constructor(private apiKeyService: EstampApiKeyService) { }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {

    if (!request.url.startsWith(ESTAMP_API_PREFIX)) {
      return next.handle(request);
    }

    let headers = request.headers.delete('Authorization');
    const apiKey = this.apiKeyService.apiKey;

    if (apiKey) {
      headers = headers.set('x-api-key', apiKey);
    }

    return next.handle(request.clone({ headers }));
  }
}
